jQuery(function($){
    if ($('.notification-banner').length == 0){
        return;
    }

    $('.notification-banner__close').on('click', function(){
        $(this).closest('.notification-banner').removeClass('active');
    });
});